export const EngagementServiceEvents = {
  init: {
    success: 'ENGAGEMENT_SERVICE.INIT.SUCCESS',
    failure: 'ENGAGEMENT_SERVICE.INIT.FAILURE',
  },
  pause: {
    started: 'ENGAGEMENT_SERVICE.PAUSE.STARTED',
    ended: 'ENGAGEMENT_SERVICE.PAUSE.ENDED',
  },
  dispose: {
    called: 'ENGAGEMENT_SERVICE.DISPOSE.CALLED',
  },
  inAppMessage: {
    received: 'ENGAGEMENT_SERVICE.IN_APP_MESSAGE.RECEIVED',
    shownControl: 'ENGAGEMENT_SERVICE.IN_APP_MESSAGE.SHOWN_CONTROL',
    deferred: 'ENGAGEMENT_SERVICE.IN_APP_MESSAGE.DEFERRED',
    shown: 'ENGAGEMENT_SERVICE.IN_APP_MESSAGE.SHOWN',
  },
}
